import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import AlbumPrintPackageOption from './AlbumPrintPackageOption';
import { getPurchasedPrintPackageCartItem } from '../../../../../../../../services/checkout/redux/helpers';
import { getCheckoutCart } from '../../../../../../../../services/checkout/redux/checkoutSelectors';
import {
  cartItemUpdate,
  togglePurchasedPrintPackageCartItem,
} from '../../../../../../../../services/checkout/redux/checkoutActions';
import { openModal as openModalAction } from '../../../../../../../../actions/modal-actions';

const propTypes = {
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string,
  }),
  albumPrintPackages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      print_package: PropTypes.shape({
        id: PropTypes.string,
      }),
      quantity: PropTypes.number,
    }),
  ).isRequired,
  prepaidPrintPackages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      identity: PropTypes.shape({
        id: PropTypes.string,
      }),
      print_package: PropTypes.shape({
        id: PropTypes.string,
      }),
      quantity: PropTypes.number,
    }),
  ).isRequired,
  cart: PropTypes.array.isRequired,
  onCartItemUpdate: PropTypes.func.isRequired,
  onPurchasedPrintPackageToggle: PropTypes.func.isRequired,
  onCheckout: PropTypes.func.isRequired,
  optionProps: PropTypes.object,
  className: PropTypes.string,
  isAllPhotos: PropTypes.bool,
  albumMembershipPhoto: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const AlbumPrintPackageOptionList = ({
  albumMembershipGroup,
  albumPrintPackages,
  prepaidPrintPackages,
  cart,
  onCartItemUpdate,
  onPurchasedPrintPackageToggle,
  onCheckout,
  optionProps,
  className,
  isAllPhotos,
  albumMembershipPhoto,
}) => {
  const classes = classNames({
    'album-print-package-option-list': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      {prepaidPrintPackages.map(purchasedPrintPackage => {
        const {
          identity,
          quantity,
          print_package: printPackage,
        } = purchasedPrintPackage;

        const albumPrintPackage = albumPrintPackages.find(
          albumPackage => albumPackage.print_package.id === printPackage.id,
        );

        if (!albumPrintPackage) {
          return null;
        }

        return (
          <AlbumPrintPackageOption
            key={purchasedPrintPackage.id}
            albumMembershipPhoto={albumMembershipPhoto}
            identity={identity}
            albumPrintPackage={albumPrintPackage}
            purchasedPrintPackage={purchasedPrintPackage}
            albumMembershipGroup={albumMembershipGroup}
            cartItem={getPurchasedPrintPackageCartItem(cart, {
              purchasedPrintPackageId: purchasedPrintPackage.id,
              photoId: albumMembershipPhoto?.photo?.id,
              identityId: identity?.id,
            })}
            onUpdate={onCartItemUpdate}
            onCheckout={onCheckout}
            isAllPhotos={isAllPhotos}
            onPurchasedPrintPackageToggle={({ photo, album }) => {
              onPurchasedPrintPackageToggle({
                albumPrintPackage,
                purchasedPrintPackage,
                albumMembershipGroup,
                identity,
                photo,
                album,
                quantity,
                // Store this, as the cart item will need to use this value.
                isAllPhotos,
              });
            }}
            {...(optionProps ?? {})}
          />
        );
      })}
    </div>
  );
};

AlbumPrintPackageOptionList.propTypes = propTypes;

const mapStateToProps = state => ({
  cart: getCheckoutCart(state),
});

const mapDispatchToProps = {
  openModal: openModalAction,
  onCartItemUpdate: cartItemUpdate,
  onPurchasedPrintPackageToggle: togglePurchasedPrintPackageCartItem,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlbumPrintPackageOptionList);
